import React, { useState } from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

import CreateQualityObservationModal from './CreateQualityObservationModal';

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
}));

const CreateQualityObservationButton = ({ refreshWorklist }) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    refreshWorklist();
  };

  return (
    <>
      <Button color="primary" variant="contained" size="medium" className={classes.button} startIcon={<AddIcon />} onClick={handleOpenModal} style={{ height: '40px' }}>
        Create Observation
      </Button>

      <CreateQualityObservationModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default CreateQualityObservationButton;
